<template>
  <div class="content">
    <div class="title">基础设置</div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="渠道商城设置" name="mini"></el-tab-pane>
      <el-tab-pane label="推广设置" name="tgSet"></el-tab-pane>
      <el-tab-pane label="接口设置" name="receivingPayments"></el-tab-pane>
    </el-tabs>
    <div class="center" v-if="activeIndex == 0">
      <div class="">
        <div class="center-title">
          <div class="bor"></div>
          基础信息
        </div>
        <div class="center-flex">
          <div class="center-text">渠道商城头像</div>
          <img class="image-header"
            :src="setFrom.appImg ? setFrom.appImg : require('@/assets/img/set_icon_head_default.png')" alt="">
        </div>
        <div class="center-flex">
          <div class="center-text">渠道商城名称</div>
          <div class="center-span">{{ setFrom.appName }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">套餐版本</div>
          <div class="center-span">{{ packageSnapshot.name }}</div>
<!--          <div class="center-button" @click="goActive">升级</div>-->
        </div>
        <div class="center-flex">
          <div class="center-text">接入时间</div>
          <div class="center-span">{{ setFrom.createTime }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">
            到期时间
            <div>(基础套餐)</div>
          </div>
          <div class="center-span" style="display: flex;align-items: center">
            {{ packageSnapshot.effectTime || '获取中...' }}
            <div class="center-button" @click="goActive">{{ getRestOfDay(packageSnapshot.effectTime) }}</div>
          </div>
        </div>
        <div class="center-flex" v-if="profitPackageSnapshot.effectTime">
          <div class="center-text">到期时间(分销套餐)</div>
          <div class="center-span" style="display: flex;align-items: center">
            {{ profitPackageSnapshot.effectTime || '获取中...' }}
            <div class="center-button" @click="goActive">{{ getRestOfDay(profitPackageSnapshot.effectTime) }}</div>
          </div>
        </div>
        <div class="center-flex">
          <div class="center-text">当前版本</div>
          <div class="center-span" v-if="miniRelease.userVersion != null">{{ miniRelease.userVersion }}</div>
        </div>
        <div class="center-flex">
          <div class="center-text">appKey</div>
          <template v-if="channelAppKey">
            <div class="center-span">{{channelAppKey}}</div>
            <div class="center-copy" v-clipboard:copy="channelAppKey" v-clipboard:success="onCopy"
                 v-clipboard:error="onError">复制
            </div>
          </template>
        </div>
        <div class="center-flex">
          <div class="center-text">appSecret</div>
          <template v-if="appSecret">
            <div class="center-span">{{appSecret}}</div>
            <div class="center-copy" v-clipboard:copy="appSecret" v-clipboard:success="onCopy"
                 v-clipboard:error="onError">复制
            </div>
          </template>
        </div>
<!--        <div class="center-flex">-->
<!--          <div class="center-text">接入文档</div>-->
<!--          <el-link type="primary" @click="goDocumentation">接入流程</el-link>-->
<!--        </div>-->
        <el-link style="font-size: 22px;margin-left: 40px;margin-top: 20px;" type="primary" @click="goDocumentation">点击查看接入流程</el-link>
<!--        <div class="center-bor"></div>-->
      </div>
<!--      <div class="center-title">-->
<!--        <div class="bor"></div>-->
<!--        消息模版-->
<!--        <div class="button" @click="synchronization()">同步消息模版</div>-->
<!--      </div>-->
<!--      <div class="center-flex" v-for="(item, index) in miniTemplateList" :key="index">-->
<!--        <img-->
<!--          :src="item.appTemplate ? require('@/assets/img/icon_checkbox_s.png') : require('@/assets/img/icon_cancel.png')"-->
<!--          alt="">-->
<!--        <div class="center-title">{{ item.remark }}</div>-->
<!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_checkbox_s.png" alt="">-->
      <!--        <div class="center-title">出票消息通知</div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_checkbox_s.png" alt="">-->
      <!--        <div class="center-title">订单关闭消息通知</div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_cancel.png" alt="">-->
      <!--        <div class="center-title">退款消息通知</div>-->
      <!--      </div>-->
      <!--      <div class="center-flex">-->
      <!--        <img src="@/assets/img/icon_checkbox_s.png" alt="">-->
      <!--        <div class="center-title">影片开场前30分钟提醒</div>-->
      <!--      </div>-->
      <!--      <div class="button-save">保存</div>-->
    </div>
    <!--    推广设置-->
    <div class="center" style="padding-top: 0;" v-if="activeIndex == 1">
      <div class="bottom">
        <div>注意：</div>
        <div class="bottom-text">1.在填写时，不管是填写<span style="color: #FF4F76">正数</span>还是<span style="color: #FF4F76">负数</span>，都需要遵循  市场价浮动>=快速购票浮动>特惠购票浮动</div>
        <div class="bottom-text">2.填写小数时，<span style="color: #FF4F76">保留两位小数</span></div>
<!--        <div  class="bottom-text">-->
<!--          3.填写浮动价格之后，<span style="color: #FF4F76">市场价、特惠购票、快速购票</span>三者的价格<span style="color: #FF4F76">不能低于原来市场价的5折，如果低于，则按照5折进行显示</span>-->
<!--        </div>-->
      </div>
      <div class="center-title">
        <div class="bor"></div>
        浮动价格设置<span style="font-size: 12px;color: #999;">（可向上、向下浮动）</span>
      </div>
      <priceFloatList v-if="activeIndex == 1"></priceFloatList>
    </div>
    <div class="center" v-if="activeName === 'receivingPayments'">
      <div>
        <el-form ref="receivingPaymentsFormRef" :model="receivingPaymentsForm" label-width="140px" :rules="rules">
          <div class="center-title">
            <div class="bor"></div>
            自定义收银台
          </div>
          <el-form-item label="H5收银台链接" prop="cashLink">
            <el-input v-model="receivingPaymentsForm.cashLink" placeholder="请输入H5收银台链接" style="width: 600px;"></el-input>
          </el-form-item>
          <el-form-item label="微信小程序" prop="wxAppLink">
            <el-input v-model="receivingPaymentsForm.wxAppLink" placeholder="请输入微信小程序支付页路径" style="width: 600px;"></el-input>
          </el-form-item>
          <div class="center-title">
            <div class="bor"></div>
            退款接口设置
          </div>
          <el-form-item label="退款接口地址" prop="refundUrl">
            <el-input v-model="receivingPaymentsForm.refundUrl" placeholder="请输入退款接口地址" style="width: 600px;"></el-input>
          </el-form-item>
          <div class="center-title">
            <div class="bor"></div>
            事件回调接口设置
          </div>
          <el-form-item label="事件回调接口地址" prop="notifyUrl">
            <el-input v-model="receivingPaymentsForm.notifyUrl" placeholder="请输入事件回调地址" style="width: 600px;"></el-input>
          </el-form-item>
        </el-form>
      </div>

    </div>
    <div class="save" v-if="![0,6,1].includes(Number(activeIndex))">
      <div class="save-button" @click="save">保存</div>
    </div>
    <!--    快出退款设置-->
    <div class="center" v-if="activeIndex == 6 && soonRefund">
      <quick-set type="zfb"></quick-set>
    </div>
  </div>
</template>

<script>
import selectBtn from '@/assets/img/official/set_btn_iselected_2.png'
import unselectBtn from '@/assets/img/official/set_btn_nochoice_1.png'
import mini from "@/api/mini";
import { matchInteger } from "@/utils/regExp";
import QuickSet from "@/views/pc/miniProgram/set/quickSet.vue";
import {urlReg} from '@/utils/regExp'
import priceFloatList from '@/views/pc/channelMiniProgram/set/priceFloat/priceFloatList.vue'


const MiniModel = new mini()
export default {
  name: "index",
  components: {QuickSet,priceFloatList},
  data() {
    return {
      soonRefund: 0,
      selectIcon: selectBtn,
      unselectIcon: unselectBtn,
      activeName: 'mini',
      actionShh: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/upload/merchant',
      action: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/params_withdraw/upload-local',
      actionPoster: process.env.VUE_APP_NEW_OPEN_URL + '/movie/open/params_post/upload-self-poster',
      uploadData: {
        appKey: localStorage.getItem('appKeyMini'),
      },
      uploadDataCode: {
        appKey: localStorage.getItem('appKeyMini'),
        imageType: 2 // 表明是二维码
      },
      activeIndex: 0,
      checkList: ['特惠购票'],
      value: false,
      time: '',
      radio: '',
      fileListShh: [],
      fileListSy: [],
      fileList12: [],
      fileList: [],
      tgFrom: {
        openCompete: 0,
        openDirect: 0,
        openSoon: 0,
        openTehuiSoon: 0,
        percentMajor: '',
        percentOne: '',
        percentTwo: '',
        secondDiscount: '',
        appKey: localStorage.getItem('appKeyMini'),
        ticketDiscountFloat: ''
      },
      txFrom: {
        appKey: localStorage.getItem('appKeyMini'),
        alipayPublicKey: '',
        alipayType: '',
        appCert: '',
        appid: '',
        certKeyRsa: '',
        endHour: '',
        isSwitch: '',
        privateKey: '',
        rootCert: '',
        startHour: '',
        withdrawMin: '',
        withdrawPart: ''
      },
      posterFrom: {
        appKey: localStorage.getItem('appKeyMini'),
        posterIds: [],
        posterUrls: [],
        selfPosterIds: []
      },
      poster: {},
      dialogShow: false,
      selfPosterId: '',
      setFrom: {},
      shhFrom: {},
      otherFrom: {
        gzhDesc: ''
      },
      packageSnapshot: {},
      profitPackageSnapshot: {},
      miniRelease: {},
      miniAudit: {},
      miniTemplateList: {},
      promotionLink: 'pages/movie/movie',
      isUpload: true,
      headers: {
        OPENTOKEN: localStorage.getItem('java-open-token')
      },
      dialogImageUrl: '',
      dialogVisible: false,
      fileListServiceUrl: [],
      deleteType: 0,
      url: 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/indexOld.jpg',
      showImage: false,
      channelAppKey:'',
      appSecret:'',
      receivingPaymentsForm:{
        cashLink: '',
        wxAppLink: '',
        refundUrl:'',
        notifyUrl:'',
      },
      rules:{
        cashLink:[
          { pattern: urlReg, message: '请输入正确的H5收银台链接', trigger: 'blur' },
        ],
        wxAppLink:[
          { pattern: /^\/.*/, message: '请输入正确的微信小程序支付页路径，以"/"开头，例如"/pages/pay/index"', trigger: 'blur' },
        ],
        refundUrl:[
          { required: true,pattern: urlReg, message: '请输入正确的退款接口地址', trigger: 'blur' },
        ],
        notifyUrl:[
          { required: false,pattern: urlReg, message: '请输入正确的事件回调接口地址', trigger: 'blur' },
        ],
      },
      floatData:[
        {
          cityIdList:['1001','1002'],
          initPriceFloat:1,
          discountPriceFloat:2.22,
          fastPriceFloat:3.44,
        },
        {
          cityIdList:['2001'],
          initPriceFloat:1,
          discountPriceFloat:0,
          fastPriceFloat:0,
        },
        {
          cityIdList:[],
          initPriceFloat:1,
          discountPriceFloat:0,
          fastPriceFloat:0,
        },
      ],
      priceFloatLoading:false,
      defaultCityList:[],
    }
  },
  mounted() {
    this.getSet()
  },
  methods: {
    async goDocumentation() {
      window.open('https://apifox.com/apidoc/shared-a194c212-6a38-45e3-b3e0-ec970864eca6')
    },
    handleClick(e) {
      console.log(e)
      this.activeIndex = e.index
      if (e.index != 5) {
        this.getSet()
      } else {
        if (this.isUpload) {
          this.getSet()
          this.isUpload = false
        }
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveZfb(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveCa(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleClose() {
      this.dialogShow = false
    },
    // 复制订单信息
    onCopy() {
      this.$message.success('复制成功！')
    },
    onError() {
      this.$message.success('复制失败！')
    },
    handleSuccess(response, file, fileList) {
      this.poster.selfPosterList.push({ image: response.data.url, state: 0, id: response.data.id })
    },
    async getSet() {
      console.log('aaaaaaaaaaaa===',this.activeIndex)
      let params = {
        appKey: this.tgFrom.appKey
      }
      if (this.activeIndex == 0) {
        MiniModel.setMini(params).then(res => {
          console.log(res,'res==========')
          if (res.data.code == 200) {
            this.setFrom = res.data.data
            this.packageSnapshot = res.data.data.packageSnapshot || {}
            this.soonRefund = res.data.data.soonRefund
            this.profitPackageSnapshot = res.data.data.profitPackageSnapshot || {}
            this.miniRelease = res.data.data.miniRelease || {}
            this.miniAudit = res.data.data.miniAudit || {}
            this.miniTemplateList = res.data.data.miniTemplateList || {}
            this.channelAppKey = res.data.data.appKey
            this.appSecret = res.data.data.appSecret
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 1) {
        // this.priceFloatLoading = true
        MiniModel.setTgMiniSearch(params).then(res => {
          if (res.data.code == 200) {
            this.tgFrom = res.data.data
            this.priceFloatLoading = false
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 2) {
        MiniModel.findChannelMallInterface(params).then(res => {
          console.log(res,'res=====findAppAppend')
          if(res.data.code !== 200) {
            this.$message.error(res.data.message || res.data.info)
            return
          }
          res.data.data.channelMallList.forEach(item => {
            if(item.type === 1) {
              this.receivingPaymentsForm.cashLink = item.cashLink
            }
            if(item.type === 2) {
              this.receivingPaymentsForm.wxAppLink = item.cashLink
            }
          })
          this.receivingPaymentsForm.refundUrl = res.data.data.refundUrl
          this.receivingPaymentsForm.notifyUrl = res.data.data.notifyUrl
        })
      }
    },
    // 保存
    async save() {
      console.log(this.activeIndex, 'this.activeIndex')
      // 推广设置
      if (this.activeIndex == 1) {
        // if (this.tgFrom.ticketDiscountFloat === '' && this.promotionForm.ticketDiscountFloat != 0) {
        //   this.$message.error('请输入折扣')
        //   return
        // }
        // if (this.tgFrom.ticketDiscountFloat > 8 || this.tgFrom.ticketDiscountFloat < -8) {
        //   this.$message.error('折扣浮动只能输入-8~8之间的整数')
        //   return;
        // }
        // if (this.tgFrom.ticketDiscountFloat.toString().indexOf('.') != -1) {
        //   this.$message.error('折扣浮动请输入整数')
        //   return;
        // }
        // if (!matchInteger.test(this.tgFrom.secondDiscount)) {
        //   this.$message.error('秒出票让利请输入正整数')
        //   return
        // }
        // if (this.tgFrom.secondDiscount > 4 || this.tgFrom.secondDiscount < 0) {
        //   this.$message.error('秒出票让利请输入0~4之间（含）的整数')
        //   return
        // }
        console.log(this.$refs.priceFloatRef,'this.$refs.priceFloatRef')
        let data = this.$refs.priceFloatRef.getData()
        console.log(data,'data======')
        return
        MiniModel.updateChannelMall(this.tgFrom).then(res => {
          if (res.data.code == 200) {
            this.$message.success('保存成功')
            this.getSet()
          } else {
            this.$message.error(res.data.info)
          }
        })
      }
      if (this.activeIndex == 2){
        this.$refs.receivingPaymentsFormRef.validate(async(valid) => {
          if(valid) {
            console.log('通过=')
            if(!this.receivingPaymentsForm.cashLink && !this.receivingPaymentsForm.wxAppLink) {
              this.$message.error('请至少填写一个收银台链接')
              return
            }
            // 1.h5 2微信 3抖音 4支付宝 5快手
            let channelMallList = [
              {
                type:1,
                cashLink:this.receivingPaymentsForm.cashLink,
              },
              {
                type:2,
                cashLink:this.receivingPaymentsForm.wxAppLink,
              },
            ]
            const res = await MiniModel.updateChannelMallInterface({
              appKey: localStorage.getItem('appKeyMini'),
              refundUrl: this.receivingPaymentsForm.refundUrl,
              channelMallList,
              notifyUrl: this.receivingPaymentsForm.notifyUrl,
            })
            if(res.data.code !== 200) {
              this.$message.error(res.data.message || res.data.info)
              return
            }
            this.$message.success('保存成功')
            this.getSet()
          }
        })
      }
    },
    upload(res) {
      console.log(res)
    },
    uploadZfb(res) {
      console.log(res)
    },
    uploadCa(res) {
      console.log(res)
    },
    getTime(e) {
      this.txFrom.startHour = e[0]
      this.txFrom.endHour = e[1]
    },
    // 节流函数
    throttle(fn, delay) {
      let timer = null
      return function () {
        if (!timer) {
          timer = setTimeout(() => {
            fn.apply(this, arguments)
            timer = null
          }, delay)
        }
      }
    },
    // 同步模版消息
    synchronization() {
      this.throttle(this.getMessage, 1000)();
    },
    getMessage() {
      let param = {
        appKey: localStorage.getItem('appKeyMini')
      }
      MiniModel.miniMessage(param).then(res => {
        if (res.data.code == 200) {
          this.$message.success('同步成功')
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    handleRemoveSy(file, fileList) {
      console.log(file, fileList);
    },
    // 上传成功钩子
    uploadSuccess(response) {
      console.log('response', response)
      this.shhFrom.mchCert = response.data
    },
    // 上传成功钩子私钥
    uploadSuccessSy(response) {
      console.log('response', response)
      this.shhFrom.mchKey = response.data
    },
    handleRemove12(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveShh(file, fileList) {
      console.log(file, fileList);
    },
    // 上传成功钩子
    uploadSuccess12(response) {
      console.log('response', response)
      this.shhFrom.mchP12 = response.data
    },
    goActive() {
      this.$router.push('/pc/channelMiniProgram/activate')
    },
    // 获取剩余天数
    getRestOfDay(createTime) {
      let _d_tm = new Date(new Date().valueOf());
      let _d_now = new Date(new Date().valueOf());
      if (createTime) {
        _d_now = new Date((createTime).replace(/-/g, "/"));
      }
      if (_d_now < _d_tm) {
        return '已过期'
      }
      if (_d_now > _d_tm) {
        return '续费'
      }
      // let leftTime =  ~~((_d_now - _d_tm) / 1000 / 60 / 60 / 24);
      // return  leftTime+'天'

    },
    handleRemoveImage(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    uploadSuccessService(response) {
      this.otherFrom.serviceUrl = response.data.url
    },
    handleView(type) {
      let url = ''
      if (type === 0) {
        url = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/indexOld.jpg'
      } else {
        url = 'https://yingpiao.oss-cn-shenzhen.aliyuncs.com/mini-img/indexNew.jpg'
      }
      this.url = url
      this.$refs.previewImg.showViewer = true
    },
    // 跳转到用户列表
    goUser() {
      this.$router.push('/pc/channelMiniProgram/user')
    }
  }
}
</script>

<style scoped lang="less">
.content {
  width: 100%;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 20px;
  position: relative;

  .title {
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 25px;
  }

  .center {
    padding: 30px;
    margin-bottom: 30px;

    .center-title {
      display: flex;
      align-items: center;
      font-size: 16px;
      font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 22px;
      margin-bottom: 10px;

      .text {
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 17px;
        margin-left: 10px;
      }

      .bor {
        width: 2px;
        height: 14px;
        background: #FF8622;
        margin-right: 8px;
      }

      .button {
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FFFFFF;
        line-height: 28px;
        width: 96px;
        height: 28px;
        background: #FF8622;
        border-radius: 2px;
        text-align: center;
        margin-left: 20px;
        cursor: pointer;
      }
    }

    .center-add {
      width: 120px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .center-image {
      height: 283px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #EEEEEE;
      padding: 20px;
      margin-top: 15px;
      display: flex;
      overflow-x: scroll;

      .image-item {
        margin-right: 20px;
        width: 120px;
        height: 213px;

        img {
          width: 120px;
          height: 213px;
        }

        .image-item-radio {
          text-align: center;

          img {
            width: 20px;
            height: 20px;
          }
        }
      }
    }

    .center-flex {
      display: flex;
      align-items: center;
      margin-top: 20px;

      .center-title {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-left: 8px;
      }

      .center-text {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 20px;
        margin-right: 30px;
        width: 90px;
        text-align: right;
      }

      .image-header {
        width: 40px;
        height: 40px;
        border-radius: 100%;
      }

      .center-span {
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #333333;
        line-height: 20px;
      }

      .center-input {
        width: 160px;
        text-align: right;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-right: 20px;

        span {
          color: #FF4F76;
        }
      }

      .center-input-span {
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 17px;
        margin-left: 7px;
        width: 500px;
      }

      .center-copy {
        width: 56px;
        height: 24px;
        background: #F5F5FA;
        border-radius: 2px;
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #999999;
        line-height: 24px;
        text-align: center;
        margin-left: 10px;
        cursor: pointer;
      }

      .center-button {
        width: 56px;
        height: 24px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 12px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 24px;
        margin-left: 10px;
        cursor: pointer;
      }
    }

    .center-bor {
      height: 1px;
      border: 1px solid #EEEEEE;
      margin-top: 40px;
      margin-bottom: 30px;
    }
  }
}

.button-save {
  width: 108px;
  height: 36px;
  background: #FF8622;
  border-radius: 2px;
  margin-top: 40px;
  text-align: center;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FFFFFF;
  line-height: 36px;
  cursor: pointer;
}

.input {
  width: 160px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #EEEEEE;
  padding: 0 10px;
}

.save {
  height: 64px;
  background: #FFFFFF;
  box-shadow: 0px -1px 4px 0px rgba(0, 0, 0, 0.1);
  width: 100%;
  position: fixed;
  bottom: 0;
  right: 0;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: center;

  //width: 73%;
  //left: 299px;
  .save-button {
    width: 108px;
    height: 36px;
    background: #FF8622;
    border-radius: 2px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
  }
}

.upload-button {
  width: 112px;
  height: 36px;
  background: #FFFFFF;
  border-radius: 2px;
  border: 1px solid #3D9EFC;
  text-align: center;
  line-height: 36px;
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #3D9EFC;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.upload-text {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
}

.delete {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF5178;
  line-height: 20px;
  cursor: pointer;
}

.dialog {
  padding: 20px 80px;

  .dialog-title {
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }

  .dialog-text {
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 24px;
    margin-top: 8px;
    text-align: center;
  }

  .dialog-button {
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;

    .button-success {
      width: 76px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }

    .button-cancel {
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}

.up {
  font-size: 14px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF8622;
  line-height: 20px;
  cursor: pointer;
}

.pagination {
  margin-top: 20px;
  text-align: right;
}

.top {
  height: 40px;
  background: #FFF6F8;
  border-radius: 4px;
  border: 1px solid #FFCAD5;
  width: 100%;
  margin-bottom: 10px;

  .top-text {
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 16px;

    .text {
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 20px;
      margin-left: 8px;

      span {
        color: #FF4F76;
      }
    }
  }
}

.form-title {
  font-size: 16px;
  color: #222222;
  text-align: left;
  font-family: Alibaba-PuHuiTi-M;
  font-weight: 500;
  border-left: 2px solid #ff8622;
  padding-left: 10px;
  margin-bottom: 20px;
  line-height: 15px;
}

.form-div {
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-bottom: 20px;
}

.form-div {
  font-size: 14px;
}

.flex {
  display: flex;
  align-items: center;
}

.form-div-hint {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
  margin-left: 10px;
  width: 60%;
}

.bottom {
  background: #FAFAFA;
  border-radius: 4px;
  padding: 12px 16px;
  margin-bottom: 20px;
}

.bottom-title {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #FF4F76;
  line-height: 17px;
  display: flex;
  align-items: center;
}

.bottom-title img {
  width: 20px;
  height: 20px;
}

.bottom-text {
  font-size: 12px;
  font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
  font-weight: normal;
  color: #999999;
  line-height: 17px;
  margin-left: 20px;
}

.form-div-text {
  width: 58px;
}

.center-service {
  margin-left: 77px;
  margin-top: 20px;
  display: flex;

  .center-service-title {
    margin-right: 20px;
  }
}

.official-item {
  display: flex;
  align-items: center;
  margin-top: 20px;

  .official-item-text {
    width: 100px;
    text-align: right;
    marigin-right: 20px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
  }

  .official-item-span {
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    line-height: 20px;
    margin-left: 10px;
    width: 50%;
  }

  input {
    width: 360px;
    height: 36px;
    background: #FFFFFF;
    border-radius: 2px;
    border: 1px solid #EEEEEE;
    padding: 0 10px;
    margin-left: 20px
  }
}

.text-view {
  color: #3D9EFC !important;
  cursor: pointer;
  margin-left: 20px;
  font-size: 12px;
}

.span-user {
  color: #3D9EFC;
  text-decoration: underline;
  cursor: pointer;
}

/deep/ .el-dialog__header {
  border-bottom: 1px solid #EEEEEE;
}

/deep/ .el-tabs__item.is-active {
  color: #FF8622 !important;
}

/deep/ .el-tabs__active-bar {
  background-color: #FF8622 !important;
}

/deep/ .el-tabs__item:hover {
  color: #FF8622 !important;
}

/deep/ .el-table th,
.el-table tr {
  background-color: #FCFAF8;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #FF8622 !important;
  border-color: #FF8622 !important;
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #FF8622 !important;
}

/deep/ .el-checkbox__inner:hover {
  border-color: #FF8622 !important;
}

/deep/ .el-radio__input.is-checked+.el-radio__label {
  color: #FF8622 !important;
}

/deep/ .el-radio__input.is-checked .el-radio__inner {
  background-color: #FF8622 !important;
  border-color: #FF8622 !important;
}

/deep/ .el-tabs__nav-wrap::after {
  height: 1px !important;
}

/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ input[type="number"] {
  -moz-appearance: textfield;
}

/deep/.el-icon-circle-close:before {
  color: #fff
}
</style>



// WEBPACK FOOTER //
// src/views/pc/channelMiniProgram/set/index.vue